// * Here should lay all components shared across
// * "List" pages

import styled from "styled-components";

export const ListBaseContainer = styled.div`
  padding: 1rem 1rem 100px 1rem;
`;
